import EnterpriseProvider from './Enterprise.provider';

export default EnterpriseProvider;
